<template>
    <v-container fluid>
        <div class="mb-2">
            <v-text-field solo dense hide-details clearable :placeholder="$vuetify.lang.t('$vuetify.common.search')" prepend-inner-icon="mdi-magnify" v-model="search" />
        </div>
        <div class="d-flex">
            <div class="patients-list">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :options.sync="options"
                        :items="filteredDevices">
                         <template v-slot:[`item`]="{index, item}">
                            <tr>
                                <td class="text-center">{{indexOf(index)}}</td>
                                <td class="text-center">
                                    <v-icon :color="item.device_status === 1 ? 'green' : 'grey darken-2'">mdi-checkbox-blank-circle</v-icon>
                                </td>
                                <td class="text-center">
                                    <template>{{item.group_name}}</template>
                                </td>
                                <td class="text-center">
                                    <template v-if="item.alias">{{item.alias}}</template>
                                    <template v-else>-</template>
                                </td>
                                <td class="text-center">
                                    <template v-if="item.pat_id">{{item.pat_id}} / {{item.pat_name}}</template>
                                    <template v-else>-</template>
                                </td>
                                <td class="text-center">
                                    <v-icon :color="item.pat_status === 1 ? 'green' : 'red'">mdi-checkbox-blank-circle</v-icon>
                                </td>
                                <td class="text-center">
                                    <template v-if="item.birth">
                                        {{item.birth | moment('add', $timezone, 'YYYY-MM-DD')}}
                                    </template>
                                    <template v-else>
                                        -
                                    </template>
                                </td>
                                <td class="text-center">
                                    <template v-if="item.gender">
                                        {{item.age}} / {{$vuetify.lang.t('$vuetify.tvsm.gendershort.' + item.gender)}} / {{item.blood}}
                                    </template>
                                    <template v-else>
                                        -
                                    </template>
                                </td>
                                <td class="text-center">
                                    <template v-if="item.height">
                                        {{item.height}}cm / {{item.weight}}kg
                                    </template>
                                    <template v-else>-</template>
                                </td>
                                <td class="text-center">
                                    <v-btn small tile light color="yellow" :disabled="item.device_status !== 1" @click="setDetailView(item)">{{$vuetify.lang.t('$vuetify.tvsm.header.detail')}}</v-btn>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </div>
        </div>
    </v-container>
</template>

<script>
export default {
    methods: {
        indexOf (index) {
            const {page, itemsPerPage} = this.options
            return this.$session.devices.length - ((page - 1) * itemsPerPage + index)
        },
        getDevice () {
            this.$session.send('devices')
        },
        setDetailView (device) {
            // if (!device.alive) return;
            let serial = device.serial_name
            // const w = window.open(`/monitor/${serial}`, `monit${serial}`, 'width=920, height=580, scrollbars=no')
            // w.focus()
            this.$router.push({name: 'Monitor', params: {serial}})
        }
    },
    computed: {
        filteredDevices () {
            return this.search 
                ? this.$session.devices.filter(v => (v.pat_id + v.pat_name + v.group_name).toLowerCase().includes(this.search.toLowerCase()))
                : this.$session.devices
        }
    },
    mounted () {
        this.getDevice()
    },
    data () {
        return {
            detail: null,
            search: '',
            options: {},
            headers: [
                { text: this.$vuetify.lang.t('$vuetify.tvsm.header.seq'), value: 'num', align: 'center', sortable: false },
                { text: this.$vuetify.lang.t('$vuetify.tvsm.header.status'), value: 'device_status', align: 'center' },
                { text: this.$vuetify.lang.t('$vuetify.tvsm.header.group'), value: 'group_name', align: 'center' },
                { text: this.$vuetify.lang.t('$vuetify.tvsm.header.deviceName'), value: 'alias', align: 'center' },
                { text: this.$vuetify.lang.t('$vuetify.tvsm.header.patientNameAndId'), value: 'pat_id', align: 'center' },
                { text: this.$vuetify.lang.t('$vuetify.tvsm.header.patientStatus'), value: 'pat_status', align: 'center' },
                { text: this.$vuetify.lang.t('$vuetify.tvsm.header.birthday'), value: 'birth', align: 'center' },
                { text: this.$vuetify.lang.t('$vuetify.tvsm.header.ageSexBloodType'), value: 'pat_stat' , align: 'center'},
                { text: this.$vuetify.lang.t('$vuetify.tvsm.header.heightWeight'), value: 'phc', align: 'center' },
                { text: this.$vuetify.lang.t('$vuetify.tvsm.header.detail'), value: 'func', align: 'center' }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
    .patients-list {
        flex: 0 1 100%;
    }
    .cam-view-cont {
        display: flex;
    }
    .cam-view {
        background-color: black;
        flex: 1 0 auto;
    }
    .clickable-row::v-deep td {
        cursor: pointer;
    }
</style>